var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"centered-message"},[_vm._v("\n        抱歉~您访问的界面不存在....\n    ")])])
}]

export { render, staticRenderFns }